// extracted by mini-css-extract-plugin
export default {"menuItems":"ViewMenu_menuItems__osj3-","menuItem":"ViewMenu_menuItem__ty6VI"};